module.exports = __webpack_public_path__ + "static/media/lakeland.b9751ad0.jpg";